// src/components/ContentSection.js
import React from "react";

const ContentSection = ({ data }) => {
  const renderItem = (item, index) => {
    switch (item.type) {
      case "h2":
        return (
          <h2 key={index} className="text-2xl font-bold text-white mt-10 mb-4">
            {item.content}
          </h2>
        );
      case "p":
        return (
          <p key={index} className="text-gray-300 leading-relaxed mb-4">
            {item.content}
          </p>
        );
      case "ul":
        return (
          <ul
            key={index}
            className="list-disc list-inside space-y-2 text-gray-300 mb-4 pl-4"
          >
            {item.items.map((li, liIndex) => (
              <li key={liIndex}>{li}</li>
            ))}
          </ul>
        );
      default:
        return null;
    }
  };

  return (
    <div className="prose prose-invert max-w-none">{data.map(renderItem)}</div>
  );
};

export default ContentSection;
